<template>
    <div>
      <a-modal
        centered
        :title="title"
        :width="1000"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel"
        cancelText="关闭">
  
  
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline"  @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :span="10">
                <a-form-item label="用户账号">
                  <a-input placeholder="请输入用户账号" v-model="queryParam.username"></a-input>
                </a-form-item>
              </a-col>
              <a-col :span="10">
                <a-form-item label="角色">
                  <a-select v-model="queryParam.roleId" mode="single" defaultValue="" placeholder="请选择角色查询">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option v-for="(role,index) in roleList" :key="index.toString()" :value="role.id">{{role.roleName}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :md="6" :sm="8">
                  <a-form-item label="学校">
                    <a-input placeholder="请输入学校查询" v-model="queryParam.school"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <a-form-item label="渠道">
                    <j-search-select-tag
                      ref="searchTag"
                      placeholder="请选择渠道"
                      v-model="queryParam.agentId"
                      :trigger-change="true"
                      :dictOptions="agentList"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="8">
                  <a-form-item label="学校">
                    <a-input placeholder="请输入学校查询" v-model="queryParam.school"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="16" :lg="16" :md="16" :sm="24">
                  <a-form-item label="参与活动">
                    <j-dict-select-tag placeholder="请选择活动" v-model="queryParam.eventId" dictCode="teaching_event,event_name,id" :disableCache="true"/>
                  </a-form-item>
                </a-col>
                <a-col :xl="8" :lg="8" :md="8" :sm="24">
                  <a-form-item label="参与项目">
                    <j-category-select placeholder="请选择活动分类" :onlyLeaf="true" v-model="queryParam.eventCategory" pcode="A05"/>
                  </a-form-item>
                </a-col>
              </template>
              <a-col :span="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
            <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
            <a style="margin-left: 24px" @click="onClearSelected">清空</a>
            <span style="float:right;">
              <a @click="loadData()"><a-icon type="sync" />刷新</a>
            </span>
          </div>
          <a-table
            size="small"
            bordered
            rowKey="id"
            :columns="columns1"
            :dataSource="dataSource1"
            :pagination="ipagination"
            :loading="loading"
            :scroll="{ y: 240 }"
            :rowSelection="{selectedRowKeys: selectedRowKeys,onSelectAll:onSelectAll,onSelect:onSelect,onChange: onSelectChange}"
            @change="handleTableChange">
  
          </a-table>
        </div>
        <!-- table区域-end -->
  
  
      </a-modal>
    </div>
  </template>
  
  <script>
    import {filterObj} from '@/utils/util'
    import {getAction} from '@/api/manage'
    import {queryMySubRole} from '@/api/api'
    import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
    import JCategorySelect from '@comp/jeecg/JCategorySelect'
    export default {
      name: "SelectUserModal",
      components: {
        JSearchSelectTag,
        JCategorySelect
      },
      data() {
        return {
          title: "选择已有用户",
          names: [],
          visible: false,
          toggleSearchStatus: false,
          placement: 'right',
          description: '',
          // 查询条件
          queryParam: {},
          roleList:[],
          // 表头
          columns1: [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 50,
              align: "center",
              customRender: function (t, r, index) {
                return parseInt(index) + 1;
              }
            },
            {
              title: '用户账号',
              align: "center",
              width: 100,
              dataIndex: 'username'
            },
            {
              title: '用户名称',
              align: "center",
              width: 100,
              dataIndex: 'realname'
            },
            {
              title: '电话',
              align: "center",
              width: 100,
              dataIndex: 'phone'
            },
            {
              title: '角色',
              align: 'center',
              dataIndex: 'rawRoleNames',
              width: 180,
            },
            {
              title: '部门',
              align: 'center',
              dataIndex: 'rawDepartNames',
              width: 180,
            },
          ],
          columns2: [
            {
              title: '用户账号',
              align: "center",
              dataIndex: 'username',
  
            },
            {
              title: '用户名称',
              align: "center",
              dataIndex: 'realname',
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: "center",
              width: 100,
              scopedSlots: {customRender: 'action'},
            }
          ],
          //数据集
          dataSource1: [],
          dataSource2: [],
          agentList: [],
          // 分页参数
          ipagination: {
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '30', '100'],
            showTotal: (total, range) => {
              return range[0] + "-" + range[1] + " 共" + total + "条"
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
          },
          isorter: {
            column: 'createTime',
            order: 'desc',
          },
          loading: false,
          selectedRowKeys: [],
          selectedRows: [],
          url: {
            list: "/sys/user/list",
          }
        }
      },
      created() {
        this.loadData();
        this.initialRoleList();
        this.getMyAgentList()
      },
      methods: {
        initialRoleList(){
          queryMySubRole().then((res)=>{
            if(res.success){
              this.roleList = res.result;
            }else{
              console.log(res.message);
            }
          });
        },
        getMyAgentList(){
          getAction("/teaching/teachingAgent/getMyAgentList").then(res=>{
            if(res.success && res.result){
              for(let i=0;i<res.result.length;i++){
                this.agentList.push({
                  title: res.result[i].agentName,
                  text: res.result[i].agentName,
                  value: res.result[i].id
                })
              }
            }
          })
        },
        searchQuery() {
          this.loadData(1);
        },
        searchReset() {
          this.queryParam = {};
          this.loadData(1);
        },
        handleCancel() {
          this.visible = false;
        },
        handleOk() {
          this.dataSource2 = this.selectedRowKeys;
          console.log("data:" + this.dataSource2);
          this.$emit("selectFinished", this.dataSource2);
          this.visible = false;
        },
        handleToggleSearch(){
          this.toggleSearchStatus = !this.toggleSearchStatus;
        },
        add() {
          this.visible = true;
        },
        loadData(arg) {
          //加载数据 若传入参数1则加载第一页的内容
          if (arg === 1) {
            this.ipagination.current = 1;
          }
          var params = this.getQueryParams();//查询条件
          getAction(this.url.list, params).then((res) => {
            if (res.success) {
              this.dataSource1 = res.result.records;
              this.ipagination.total = res.result.total;
            }
          })
        },
        getQueryParams() {
          var param = Object.assign({}, this.queryParam, this.isorter);
          param.field = this.getQueryField();
          param.pageNo = this.ipagination.current;
          param.pageSize = this.ipagination.pageSize;
          return filterObj(param);
        },
        getQueryField() {
          //TODO 字段权限控制
        },
        onSelectAll(selected, selectedRows, changeRows) {
          if (selected === true) {
            for (var a = 0; a < changeRows.length; a++) {
              this.dataSource2.push(changeRows[a]);
            }
          } else {
            for (var b = 0; b < changeRows.length; b++) {
              this.dataSource2.splice(this.dataSource2.indexOf(changeRows[b]), 1);
            }
          }
          // console.log(selected, selectedRows, changeRows);
        },
        onSelect(record, selected) {
          if (selected === true) {
            this.dataSource2.push(record);
          } else {
            var index = this.dataSource2.indexOf(record);
            //console.log();
            if (index >= 0) {
              this.dataSource2.splice(this.dataSource2.indexOf(record), 1);
            }
  
          }
        },
        onSelectChange(selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys;
          this.selectionRows = selectedRows;
        },
        onClearSelected() {
          this.selectedRowKeys = [];
          this.selectionRows = [];
        },
        handleDelete: function (record) {
          this.dataSource2.splice(this.dataSource2.indexOf(record), 1);
        },
        handleTableChange(pagination, filters, sorter) {
          //分页、排序、筛选变化时触发
          console.log(sorter);
          //TODO 筛选
          if (Object.keys(sorter).length > 0) {
            this.isorter.column = sorter.field;
            this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
          }
          this.ipagination = pagination;
          this.loadData();
        }
      }
    }
  </script>
  <style lang="less" scoped>
    .ant-card-body .table-operator {
      margin-bottom: 18px;
    }
  
    .ant-table-tbody .ant-table-row td {
      padding-top: 15px;
      padding-bottom: 15px;
    }
  
    .anty-row-operator button {
      margin: 0 5px
    }
  
    .ant-btn-danger {
      background-color: #ffffff
    }
  
    .ant-modal-cust-warp {
      height: 100%
    }
  
    .ant-modal-cust-warp .ant-modal-body {
      height: calc(100% - 110px) !important;
      overflow-y: auto
    }
  
    .ant-modal-cust-warp .ant-modal-content {
      height: 90% !important;
      overflow-y: hidden
    }
  </style>